module.exports = __webpack_public_path__ + "static/media/05-1.74ed75a8.webp";